import { IconMoodEmpty, IconMoodSad, IconMoodSmile } from "@tabler/icons-react";
import type { ReactNode } from "react";

export enum Impression {
  POSITIVE = "2",
  NEUTRAL = "1",
  NEGATIVE = "0",
}

export const impressionTranslations: Record<Impression, string> = {
  [Impression.POSITIVE]: "Positiv",
  [Impression.NEGATIVE]: "Negativ",
  [Impression.NEUTRAL]: "Neutral",
};

export function getImpressionMarks() {
  return Object.values(Impression).map((value) => ({
    value: Number.parseInt(value, 10),
    label: impressionIcons[value],
  }));
}

export function getImpressionOptions() {
  return Object.values(Impression).map((value) => ({
    value,
    label: impressionTranslations[value],
  }));
}

export const impressionIcons: Record<Impression, ReactNode> = {
  [Impression.NEGATIVE]: <IconMoodSad size="2rem" color="red" />,
  [Impression.NEUTRAL]: <IconMoodEmpty size="2rem" color="orange" />,
  [Impression.POSITIVE]: <IconMoodSmile size="2rem" color="green" />,
};

export const impressionTranslationsShort: Record<Impression, string> = {
  [Impression.POSITIVE]: "+",
  [Impression.NEGATIVE]: "-",
  [Impression.NEUTRAL]: "/",
};
